export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Come ricevo il materiale?',
    answer:
      'Riceverai accesso immediato dopo il pagamento. I materiali sono digitali e possono essere consultati da computer, tablet o smartphone.',
  },
  {
    question: 'È solo per allenatori esperti?',
    answer:
      'No. La struttura progressiva permette di partire dai fondamentali e aumentare gradualmente difficoltà, movimento, collaborazione e condizioni di gioco.',
  },
  {
    question: 'Gli esercizi sono spiegati solo con testo?',
    answer:
      'No. Il sistema è stato progettato con un forte approccio visuale: sequenze, giocatori in posizione, traiettorie, diagrammi, movimenti ed errori/correzioni.',
  },
  {
    question: 'Posso adattare gli allenamenti al mio gruppo?',
    answer:
      'Sì. Il sistema utilizza varianti, semplificazioni e progressioni per modificare difficoltà, distanze, numero di giocatori e organizzazione.',
  },
  {
    question: "Devo seguire le sessioni esattamente nell'ordine?",
    answer:
      "No. Puoi seguire il percorso progressivo oppure scegliere una seduta in base all'obiettivo che vuoi allenare.",
  },
  {
    question: 'È un prodotto fisico?',
    answer: 'No. È un sistema digitale.',
  },
  {
    question: 'Come funziona la garanzia di 7 giorni?',
    answer:
      "Hai 7 giorni per verificare l'accesso e che il materiale ricevuto corrisponda a quanto descritto nell'offerta.",
  },
]
